import { render, staticRenderFns } from "./DatasetTableData.vue?vue&type=template&id=d5308834&scoped=true&"
import script from "./DatasetTableData.vue?vue&type=script&lang=js&"
export * from "./DatasetTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5308834",
  null
  
)

export default component.exports